import { AnimatePresence, motion } from 'framer-motion'
import React, { Fragment, useEffect, useRef, useState } from 'react'
import toast from 'react-hot-toast'
import { BsBellFill } from 'react-icons/bs'
import { useQuery } from 'react-query'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import { getCourseInfo } from '@/api/center'
import picEmpty from '@/assets/images/pic_empty.png'

import ImgPlaceholder from '../ImgPlaceholder'
import Loadding from '../Loadding'

interface Props {
  courseId: number
}
export default ({ courseId }: Props) => {
  const [detail, setDetail] = useState({})

  const { isLoading, data } = useQuery(['getCourseInfo', courseId], (props) => {
    if (props.queryKey[1]) {
      return getCourseInfo({
        courseId: props.queryKey[1]
      })
    } else {
      toast('暂无课件', { icon: <BsBellFill className="text-[#ff3300]" /> })
    }
  })
  useEffect(() => {
    if (data && data.status === 0) {
      const viewTitle = ['教学目标', '材料准备', '参考范画']
      const { cover, title, no, left, right } = data.data
      const l = left.filter((item: { title: string }) => {
        return viewTitle.includes(item.title)
      })
      const r = right.filter((item: { title: string }) => {
        return viewTitle.includes(item.title)
      })
      setDetail({
        cover,
        no,
        title,
        left: l,
        right: r
      })
    }
  }, [data])

  return (
    <Container>
      <Loadding state={isLoading}>
        <div className="h-[180px] w-full overflow-hidden relative flex items-start flex-col justify-end">
          <ImgPlaceholder className=" absolute top-0 left-0 w-full h-full m-auto object-cover" src={detail.cover} alt="" />
          <div className="text-[14px] text-[#FFF] py-[5px] px-[10px] my-[10px] bg-[#00000040] z-10">{detail.no}</div>
          <div className="text-[20px] text-[#FFF] py-[5px] px-[10px] my-[10px] bg-[#00000040] z-10 w-full overflow-hidden text-ellipsis whitespace-nowrap">{detail.title}</div>
        </div>
        <div className=" p-[20px]">
          {detail.left && detail.left.length ? (
            detail.left.map(({ content, title }, i) => (
              <div key={i}>
                <div className="text-[16px] text-[#4D4D4D] my-[10px]">{title}</div>
                <div>
                  {content ? (
                    <pre className="whitespace-pre-wrap">{content}</pre>
                  ) : (
                    <div className=" text-center">
                      <ImgPlaceholder src={picEmpty} className="w-[80px] m-auto" />
                      <span className="text-[12px] text-[#999]">{`暂无${title}`}</span>
                    </div>
                  )}
                </div>
              </div>
            ))
          ) : (
            <div>
              <div className="text-[16px] text-[#4D4D4D] my-[10px]">课件描述</div>
              <div>
                <div className=" text-center">
                  <ImgPlaceholder src={picEmpty} className="w-[80px] m-auto" />
                  <span className="text-[12px] text-[#999]">暂无课件描述</span>
                </div>
              </div>
            </div>
          )}
          {detail.right && detail.right.length ? (
            detail.right.map(({ content, title }, i) => (
              <div key={i}>
                <div className="text-[16px] text-[#4D4D4D] my-[10px]">{title}</div>
                <div className="flex flex-wrap justify-evenly">
                  {content && content.length > 0 ? (
                    content.map(({ url }, index) => (
                      <div className=" w-[190px] h-[150px] flex items-center justify-center" key={index}>
                        <ImgPlaceholder src={url} alt="" />
                      </div>
                    ))
                  ) : (
                    <div className=" text-center">
                      <ImgPlaceholder src={picEmpty} className="w-[80px] m-auto" />
                      <span className="text-[12px] text-[#999]">{`暂无${title}`}</span>
                    </div>
                  )}
                </div>
              </div>
            ))
          ) : (
            <div>
              <div className="text-[16px] text-[#4D4D4D] my-[10px]">课件范画</div>
              <div>
                <div className=" text-center">
                  <ImgPlaceholder src={picEmpty} className="w-[80px] m-auto" />
                  <span className="text-[12px] text-[#999]">暂无课件范画</span>
                </div>
              </div>
            </div>
          )}
        </div>
      </Loadding>
    </Container>
  )
}

const Container = styled(motion.div)``
